import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import i18n from "../../../constants/i18n";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getFirebaseStore from "../../../stores/firebase-store";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";

const KhattabatNotificationPermissionDialog = withLiteObserverAndTheme(() => {
  const { answerNotificationPermissionPopUp } = getCorePopUpStore();
  const { enableNotifications } = getFirebaseStore();

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={answerNotificationPermissionPopUp}
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center">
          <Box sx={{ flex: 1 }}>{i18n.get("NOTIFICATIONS_REQUIRED_TITLE")}</Box>
          <IconButton
            aria-label={i18n.get("KHATTABAT_CLOSE")}
            onClick={answerNotificationPermissionPopUp}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography>{i18n.get("NOTIFICATIONS_REQUIRED_MESSAGE")}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={enableNotifications}>
          {i18n.get("OKAY")}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default KhattabatNotificationPermissionDialog;
